/* eslint-disable @typescript-eslint/no-explicit-any */
export type Props = {
    inProgress?: boolean
    answer?: string | number | any[] | null
    resultType?: string
    resultStatus?: boolean
    limitedTableHeight?: boolean
    sortedTableColumns?: string[]
    showTableFixingColumnIcon?: boolean
    isFullScreen?: boolean
    shouldRenderSuggestions?: boolean
    suggestions?: string | string[]
    imageStoreBaseUrl?: string
    onSuggestionClick?: (suggestion: string) => void
}

export enum AnswerTypes {
    Array = 'array',
    Dataframe = 'dataframe',
    StringifiedArray = 'stringified-array',
    Image = 'image',
    Chart = 'chart',
    String = 'string',
    Snail = 'snail',
    Mixed = 'mixed',
}
